import classNames from 'classnames';
import { Icon } from 'palette/Icon';
import { Small } from 'palette/Typography';

import './ToggleError.scss';

interface IToggleErrorProps {
    error: string;
    className?: string;
}

function ToggleError({
    error,
    className,
}: IToggleErrorProps) {
    return (
        <div className={classNames('palette-toggle-error', className)}>
            <Icon
                className="palette-toggle-error__icon"
                color="red-700"
                name="palette_error"
                size="x-small"
            />
            <Small color="attention">
                {error}
            </Small>
        </div>
    );
}

export default ToggleError;
